import { useState, useRef } from 'react';
import useScrollReveal from '../../hooks/useScrollReveal';
import styles from './whyNowScreen.module.css';
import FormModal from '../../components/formModal/FormModal';

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M19 12H5M12 5l-7 7 7 7" />
  </svg>
);

function WhyNowScreen() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const sectionRef = useRef(null);
  useScrollReveal(sectionRef);

  return (
    <>
      <section className={styles.whyNow} ref={sectionRef}>
        <div className={styles.glowCenter} />
        <div className={styles.arcLeft} />
        <div className={styles.arcRight} />

        <div className={styles.container}>
          <div className={styles.inner}>
            <h2 className={styles.h2} data-sr="0">
              ולמה שנדבר דווקא <em className={styles.em}>עכשיו</em>..?
            </h2>

            <p className={styles.p} data-sr="0.08">
              את כבר יודעת שאת רוצה שינוי. ההרגשה הזו שאת יכולה יותר  -  היא לא הולכת לשום מקום. היא רק הולכת וגוברת.
            </p>

            <p className={styles.p} data-sr="0.14">
              האמת? <span className={styles.underline}>אין רגע מושלם.</span> הנשים שהצליחו? הן לא חיכו שזה יהיה נוח. הן פשוט החליטו שזה קורה עכשיו.
            </p>

            <p className={styles.p} data-sr="0.2">
              ברגע שתגידי <span className={styles.underline}>"אני עושה את זה"</span>  -  כל השאר מסתדר.{' '}
              <strong>ואני כאן כדי לוודא שהצעד הראשון שלך יהיה הכי נכון.</strong>
            </p>

            <div className={styles.ctaWrap} data-sr="0.26">
              <button className={styles.ctaBtn} onClick={() => setIsFormOpen(true)}>
                אני מוכנה להתחיל
                <ArrowIcon />
              </button>
              <p className={styles.ctaSub}>ללא התחייבות  -  בואי נדבר ביחד</p>
            </div>
          </div>
        </div>
      </section>

      <FormModal isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </>
  );
}

export default WhyNowScreen;
